import { React } from "react";
import { Button, WithRecord, useNotify, useDataProvider, SimpleShowLayout, useRefresh, ShowButton } from "react-admin";
import LockIcon from "@mui/icons-material/Lock";
import { Box, Typography } from "@mui/material";
import { getPermissions } from "auth/security/securityUtils";
import { checkPermission, getUserData } from "server/security/utils";
import permissions from "app/permissions";

export const LockedCandidacy = () => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const userPermissions = getPermissions();
  const hasUnlockCandidaciesPermission = checkPermission(userPermissions, permissions.canUnlockCandidacies);
  const hasPreviewCandidaciesPermission = checkPermission(userPermissions, permissions.canPreviewCandidacies);
  const userData = getUserData();

  return (
    <Box sx={{ width: "fit-content", display: "flex", alignItems: "center" }}>
      <WithRecord
        render={record => {
          return record.lockedBy ? (
            <>
              <SimpleShowLayout sx={{ width: "100%", paddingLeft: "0px" }}>
                <Typography
                  color={"primary"}
                  sx={{
                    fontSize: "12px",
                    width: "max-content",
                    fontWeight: "bold",
                    marginBottom: "-8px",
                    marginTop: "-5px",
                  }}
                >
                  Заключена от
                </Typography>
                <Typography sx={{ fontSize: "14px", width: "max-content" }}>{record?.lockerNames}</Typography>
              </SimpleShowLayout>
              {hasUnlockCandidaciesPermission || record.lockedBy === userData?.userId ? (
                <Button
                  onClick={() => {
                    return dataProvider
                      .create(`candidate/candidacies/${record.id}/unlock`)
                      .then(() => {
                        refresh();
                        notify("Успешно отключен", { type: "success" });
                      })
                      .catch(error => {
                        notify("Заявката не може да бъде изпълнена", { type: "error" });
                      });
                  }}
                >
                  <LockIcon
                    titleAccess="Отключи за редакция"
                    sx={{ color: "#e31212" }}
                  />
                </Button>
              ) : null}
            </>
          ) : (
            hasPreviewCandidaciesPermission && <ShowButton />
          );
        }}
      />
    </Box>
  );
};
